<script>
export default {
    name: 'Sidebar',
    data: () => ({
        active: true
    })
};
</script>
